export enum Asr {
  SKIP_ASR = "skipAsr",
  SKIP_CONTRACT = "skipContract",
  ASR_STATUS = "statusAsr",
}
